import type { JSX } from "solid-js";
import { Link } from "@/lib/u-router";
import { ArrowLeft } from "lucide-solid";
import { cn } from "@famidex/shared";

interface PageHeaderProps {
  title: string;
  description?: string;
  backTo?: string;
  icon?: (props: { class?: string }) => JSX.Element;
  class?: string;
}

export function PageHeader(props: PageHeaderProps) {
  return (
    <div class={cn("flex items-center gap-4 select-none", props.class)}>
      {props.backTo && (
        <Link
          to={props.backTo}
          class="p-2 rounded-full hover:bg-secondary/20 transition-colors border border-border/10 cursor-pointer shrink-0"
        >
          <ArrowLeft class="h-5 w-5 text-foreground/80" />
        </Link>
      )}
      <div>
        <h1 class="text-3xl font-extrabold tracking-tight flex items-center gap-2">
          {props.icon && <props.icon class="h-8 w-8 text-primary shrink-0" />}
          {props.title}
        </h1>
        {props.description && <p class="text-sm text-muted-foreground mt-1">{props.description}</p>}
      </div>
    </div>
  );
}
